import React, { useEffect, useState } from "react";
import { Container, Row, Col, Jumbotron, Button } from "react-bootstrap";
import classnames from 'classnames';

function Banner(props) {
    const { btn_show } = props;
    const [mobile, setMobile] = useState(false);
    useEffect(() => {
        window.scrollTo(0,0)
        if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
            setMobile({ mobile: true });
        }
    }, []);
// console.log(props.className);
    return (
        <div>
            <Jumbotron className={classnames("innerpage-bg m-0 p-0 mt-5", props.className)}>
                <Container>
                    <Row>
                        <Col md="6" className={!mobile ? "content-text-inner " : "content-text-inner text-center"}>
                            <h1 className="inner-content">{props.heading}</h1>
                            <p className="inner-content-sub-text">{props.details}</p>
                            {!!btn_show ? (
                                <div className="text-left">
                                    <Button className="btn buy-button mr-2 btn-trial mt-2">
                                        <span style={{ color: "black" }}>FREE TRIAL</span>
                                    </Button>
                                    {!props.checkPricing?
                                    <Button className="btn price-button mt-2">Check Pricing</Button>
                                    :""}
                                </div>
                            ) : (
                                ""
                            )}
                        </Col>
                    </Row>
                </Container>
            </Jumbotron>
        </div>
    );
}

export default Banner;
